import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    selections: [],
    fields: [],
    selectedType: {
      list: [],
      data: {},
      selection: []
    },
    nextStep: 0,
    typeForm: {},
    generalForm: {
      comment: '',
      receiveTime: '',
      completeTime: ''
    },
    serviceRequestStatus: null,
    serviceRequestType: null,
    selectedServiceRequest: null
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Osm/ServiceRequest/store/index.js